import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

type Props = {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onCancel?: () => void;
  sending?: boolean;
  streamStatus?: string | null;
};

const ChatComposer: React.FC<Props> = ({
                                         value,
                                         onChange,
                                         onSend,
                                         onCancel,
                                         sending,
                                         streamStatus,
                                       }) => {
  return (
    <Box mt={2}>
      {streamStatus ? (
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          {sending ? <CircularProgress size={14} /> : null}
          <Typography variant="caption" color="text.secondary">
            {streamStatus}
          </Typography>
        </Box>
      ) : null}

      <Stack direction="row" spacing={1}>
        <TextField
          fullWidth
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Ask something..."
          multiline
          minRows={2}
          maxRows={8}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
              event.preventDefault();
              if (!sending && value.trim()) onSend();
            }
          }}
        />

        <Stack spacing={1}>
          <Button
            variant="contained"
            onClick={onSend}
            disabled={!!sending || !value.trim()}
          >
            Send
          </Button>

          {sending && onCancel ? (
            <Button variant="outlined" color="inherit" onClick={onCancel}>
              Stop
            </Button>
          ) : null}
        </Stack>
      </Stack>
    </Box>
  );
};

export default ChatComposer;